import { ProductConfigurationOrigin } from '../data/model';

export interface HasConfigurationCodeOrigin {
  configurationCodeOrigin: ProductConfigurationOrigin;
}
export class LineItemActionToggles {
  static canEdit = (item: HasConfigurationCodeOrigin): boolean => {
    return LineItemActionToggles.defaultConfiguratorOrigin(item);
  };

  static hasImages = (item: HasConfigurationCodeOrigin): boolean => {
    return LineItemActionToggles.defaultConfiguratorOrigin(item);
  };

  private static defaultConfiguratorOrigin = (item: HasConfigurationCodeOrigin): boolean => {
    return item.configurationCodeOrigin === ProductConfigurationOrigin.DefaultConfigurator;
  };
}
